import type { Components, Theme } from "@mui/material";

export const MuiMenu: Components<Theme>["MuiMenu"] = {
  styleOverrides: {
    paper: () => {
      return {
        borderRadius: "1rem",
      };
    },
  },
  variants: [
    {
      props: {
        variant: "menu",
      },
      style: ({ theme }) => {
        return {
          borderRadius: "1rem",
          padding: ".5rem",
          border: `1px solid ${theme.palette.secondary.dark}`,
          boxShadow: "0px 4px 30px 0px rgba(0, 0, 0, 0.10)",
        };
      },
    },
  ],
};
